import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'


const tutores = () => import('@/components/views/tutores');
const titulados = () => import('@/components/views/titulados');
const empresas = () => import('@/components/views/empresas');
const colaboradores = () => import('@/components/views/colaboradores');
const faqs = () => import('@/components/views/faqs');
const programasyofertas = () => import('@/components/views/programas-y-ofertas');
const fichaprogramayoferta = () => import('@/components/views/ficha-programas-y-ofertas');
const cookies = () => import('@/components/views/cookies');

import Contacto from '@/components/views/contacto'


import Error404 from '@/components/views/error-404'

Vue.use(Router)


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

const router = new Router({
	mode : 'history',
	routes: [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta : {
			title : 'Agencia de Colocación| EMPLEA2'
		}
	},
	{
		path: es.contacto,
		name: 'contacto',
		component: Contacto,
		meta : {
			title : 'Contacto'
		}
	},
	{
		path: es.tutores,
		name: 'tutores',
		component: tutores,
		meta : {
			title : 'Tutores'
		}
	},
	{
		path: es.titulados,
		name: 'titulados',
		component: titulados,
		meta : {
			title : 'Titulados'
		}
	},
	{
		path: es.empresas,
		name: 'empresas',
		component: empresas,
		meta : {
			title : 'Empresas'
		}
	},
	{
		path: es.colaboradores,
		name: 'colaboradores',
		component: colaboradores,
		meta : {
			title : 'Colaboradores'
		}
	},
	{
		path: es.programasyofertas,
		name: 'programas-y-ofertas',
		component: programasyofertas,
		meta : {
			title : 'Programas y ofertas'
		}
	},
	{
		path: `${es.programasyofertas}/:id?`,
		name: 'ficha-programas-y-ofertas',
		component: fichaprogramayoferta,
		meta : {
			title : 'Programas y ofertas'
		}
	},
	{
		path: es.faqs,
		name: 'faqs',
		component: faqs,
		redirect: '/',
		meta : {
			title : 'Faqs'
		}
	},
	{
		path: es.cookies,
		name: 'cookies',
		component: cookies,
		meta : {
			title : 'cookies'
		}
	},
	{ path: '*', redirect: '/' },
	{ path: "/", component: Error404 }
	],
	scrollBehavior (to, from, savedPosition) {
		if(savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

// import VueGtm from 'vue-gtm';

// Vue.use(VueGtm, {
//   id: 'G-KGQVY0WF6S', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
//   enabled: document.cookie.includes('cookieyes-analytics=yes'), // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: false, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
// });

router.beforeEach((to, from, next) => {
	
	let meta;

	// (to.path == "/") ? meta = to.meta[lang] : meta = to.meta;

	if(!!to.meta){	
		document.title = to.meta.title
		// document.head.querySelector("[name=description]").content = meta.description;
	}

	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js